import { Box, Grid, styled, Typography } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";

const FooterBaseGrid = styled(Grid)({
  paddingLeft: "5%",
  paddingRight: "5%",
  minHeight: "10vh",
  width: "100%",
  color: "white",
});

const FooterBaseBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#00ACED",
  width: "100%",
  marginTop: "3%",
}));

const ClearLink = styled(Link)({
  color: "white",
  textDecoration: "none",
  textTransform: "none",
  paddingLeft: "5%",
  paddingRight: "5%",
});

export interface IFooterProps {}

export function Footer(props: IFooterProps) {
  return (
    <FooterBaseBox>
      <FooterBaseGrid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid container item sm={12} md={8} justifyContent="flex-start">
          <Typography>
            © PT Indomobil Sukses Internasional Tbk 2022. All Rights Reserved.
          </Typography>
        </Grid>
        <Grid container item sm={12} md={4} justifyContent="center">
          <ClearLink
            to="/Legal/TermsAndCondition"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Terms and Condition
          </ClearLink>
          |
          <ClearLink
            to="/Legal/PrivacyPolicy"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Privacy Policy
          </ClearLink>
        </Grid>
      </FooterBaseGrid>
    </FooterBaseBox>
  );
}
